/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
function ModuleError(module, err) {
	Error.call(this);
	Error.captureStackTrace(this, ModuleError);
	this.name = "ModuleError";
	this.module = module;
	this.message = err;
	this.error = err;
}
module.exports = ModuleError;

ModuleError.prototype = Object.create(Error.prototype);



//////////////////
// WEBPACK FOOTER
// (webpack)-core/lib/ModuleError.js
// module id = 4059
// module chunks = 0